export default __webpack_public_path__ + "static/media/avatar-4.9b88244f.svg";